// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.
//
// CareRx billing calls that are not in the frozen api/client.ts (E-05). Used by both the CareRx
// Billing & Agency tab and POT classic's /pot/billing.
import { jsonRequest as req } from './http'

/** asp-pot's LOA lifecycle; the server refuses any other move (CareRxBillingFunctions.LoaTransitions). */
export const LOA_NEXT: Record<string, string[]> = {
  draft: ['sent', 'signed', 'voided'], sent: ['draft', 'signed', 'voided'], signed: ['expired', 'voided'], expired: ['voided'], voided: [],
}

/** Move an LOA along its lifecycle; "signed" is what makes its rate card invoiceable. */
export const setCareRxLoaStatus = (id: string, status: string) =>
  req<{ id: string; status: string }>('PUT', `/carerx/loas/${id}/status`, { status })
